import { colors } from "./colors";
export var borders = {
  flat: "0.1rem solid " + colors.gray[500]
};